import "core-js/modules/es.array.fill.js";
export var inputNumberPortalTokens = {
  sizes: {
    s: {
      paddingY: 7,
      paddingX: 5,
      iconSize: 18,
      buttonSize: 28,
      actionIconWrapperMargins: 2,
      actionIconWrapperMarginToInput: 4
    },
    m: {
      paddingY: 10,
      paddingX: 8,
      iconSize: 24,
      buttonSize: 32,
      actionIconWrapperMargins: 4,
      actionIconWrapperMarginToInput: 6
    },
    l: {
      paddingY: 12,
      paddingX: 10,
      iconSize: 30,
      buttonSize: 40,
      actionIconWrapperMargins: 4,
      actionIconWrapperMarginToInput: 6
    }
  },
  actionIconWrapper: {
    iconDisabledColor: function iconDisabledColor(_ref) {
      var color = _ref.color;
      return color.fill.icon.base;
    },
    backgroundHoverColor: function backgroundHoverColor(_ref2) {
      var palette = _ref2.palette;
      return palette.neutralsBlack.hex5;
    },
    iconHoverColor: function iconHoverColor(_ref3) {
      var color = _ref3.color;
      return color.fill.icon.base;
    },
    borderRadius: 8,
    opacityOnDisable: 0.5
  }
};